import React from "react";
import "./Agreement.scss";
import { setItem } from "../../util/util";
import http from "../../util/api";
import {Toast, Icon, SearchBar } from "antd-mobile";
import qs from "qs";
import Loading from "../../components/Loading";

class Agreement extends React.Component {
  state = {
    loading:false,
    str:'<div>测试内容</div>',
    renew:0,
    userData:{},
    version:'',
    returnroute:'',
    showBtn:1,
  };
  async componentDidMount() {
   this.getData();
  }
  getData=async()=>{
    const search = document.location.search;
    const querystring = search.substring(1);
    const {renew} = qs.parse(querystring);
    const {returnroute} = qs.parse(querystring);
    const {showbtn} = qs.parse(querystring);
    this.setState({renew,returnroute});
    if(showbtn){
      this.setState({showBtn:showbtn});
    }
    if(renew){
    this.setState({loading:true});
      try {
        const res = await http().getTable({
          resid:685126368952,
          cmswhere:`brid = '隐私协议'`
        });
        if(renew==1){
          const res2 = await http().getTable({
            resid:685988118358
          });
          if(res2.data.data.length>0){
            this.setState({userData:res2.data.data[0]});
          }else{
            Toast.fail('未能获取到用户信息，请重新登录',1);
            this.props.history.push('/login');
          }
        }
        if(res.data.data.length>0){
          this.setState({version:res.data.data[0].version,str:res.data.data[0].contenText,loading:false});
        }else{
          Toast.fail('获取协议内容失败',1);
          this.setState({loading:false});
        }
      } catch (error) {
        console.error(error);
        this.setState({loading:false});
        Toast.fail(error.message);
      }
    }
   
  }
  submit=async()=>{
    if(this.state.renew=='1'){
    this.setState({loading:true});

      try {
        let obj = this.state.userData;
        obj.agreementVersion=this.state.version;
        const res = await http().modifyRecords({
          resid:685988118358,
          data:[obj]
        });
    this.setState({loading:false});

        Toast.success('成功',1)
        this.props.history.go(-1);
      } catch (error) {
        console.error(error);
        this.setState({loading:false});
        Toast.fail(error.message);
      }
    }else{
      this.props.history.push('/'+this.state.returnroute+'?agree=1')
    }
  }
  render() {
    return (
      <div className="agreement">
        {this.state.loading?<Loading/>:null}
       {/* <div className='header'>
         <div className='logo' onClick={()=>{
                    this.props.history.push('/');
                  }}>主页</div>
        </div> */}
        <div className='container'>
              <span
              className='back'
              onClick={()=>{
                this.props.history.go(-1);
              }}
              >取消</span>

              <h3>
               隐私协议
              </h3>
              <div className='text' dangerouslySetInnerHTML={{ __html: this.state.str}}>

              </div>
        </div>
        {
          this.state.showBtn==1?
          <div className='mainBtn' onClick={()=>{
            this.submit();
                    }}>
            我已阅读并同意
          </div>
          :null
        }
        
      </div>
    );
  }
}

export default Agreement;
